import * as React from 'react';

import {ButtonGroup} from '../../button-group/button-group';

import styles from './layout.module.css';

type Props = {
    children: React.ReactNode;
};

type ModalMainProps = Props & {
    fullheight?: boolean;
};

type LeftFrameProps = Props & {
    title?: string;
};

type NavButtonsProps = Props & {
    style?: any;
};

type FooterWithControlsProps = {
    controls: React.ReactNode;
    buttons: React.ReactNode;
};

type ModalMainIllustrationContainerProps = Props & {
    minHeight?: 140 | 160 | 180 | 200 | 220 | 240 | 260 | 280 | 300;
};

export function ModalMain(props: ModalMainProps) {
    return (
        <div className={props.fullheight ? styles['modal-body--fullheight'] : styles['modal-body']}>
            {props.children}
        </div>
    );
}

export function RightFrame(props: Props) {
    return <div className={styles['right-frame']}>{props.children}</div>;
}

export function LeftFrame(props: LeftFrameProps) {
    return (
        <div className={styles['left-frame']}>
            <div className={styles['step-header']}>{props.title}</div>
            {props.children}
        </div>
    );
}

export function NavButtons(props: NavButtonsProps) {
    return (
        <div style={props.style} className={styles['nav-buttons']}>
            <ButtonGroup>{props.children}</ButtonGroup>
        </div>
    );
}

export function FooterWithControls(props: FooterWithControlsProps) {
    return (
        <div className={styles['footer']}>
            {props.controls}
            <ButtonGroup>{props.buttons}</ButtonGroup>
        </div>
    );
}

export function ModalMainIllustrationContainer(props: ModalMainIllustrationContainerProps) {
    const minHeight = props.minHeight ? `${props.minHeight}px` : undefined;

    return (
        <div style={{minHeight}} className={styles['modal-main-illustration-container']}>
            {props.children}
        </div>
    );
}
